// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Umbrella/index.css
// module id = 2571
// module chunks = 0